import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxDocViewerComponent } from 'ngx-doc-viewer';

import { Transporter } from '../../../models/transporter.model';
import { TransporterEnum } from '../../../models/enums/transporter-enum.enum';
import { CurrentDataService } from '../../../services/current-data-service';

@Component({
  selector: 'jhi-cgv',
  templateUrl: './cgv.component.html',
  styleUrls: ['./cgv.component.scss'],
})
export class CgvComponent implements OnInit {
  @ViewChild('docViewerComponent')
  docViewerComponent!: NgxDocViewerComponent;

  transporter!: Transporter;
  doc?: string;
  loadingSpinner = 'loadingSpinner';

  oldTransporterFormat: string[] = [TransporterEnum.TAROT.technicalName];

  constructor(protected cds: CurrentDataService, public spinnerService: NgxSpinnerService) {
    this.cds.getCurrentTransporter().subscribe(value => {
      if (value) {
        this.transporter = value;
        this.doc = 'https://storage.googleapis.com/bary-doc-transporters/cgv/cgv-' + value.technicalName + '.docx';
      }
    });
  }

  ngOnInit(): void {
    this.spinnerService.show(this.loadingSpinner).then();
    this.cds.getCurrentTransporter().subscribe(value => {
      if (value) {
        this.transporter = value;
      }
    });
  }
}
